import { Link } from "react-router-dom";
import { Heart, Star } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { fmt } from "@/api";

export default function ProductCard({ p }) {
  const { addToCart, toggleWishlist, wishlistIds } = useApp();
  const disc = p.mrp > p.price ? Math.round(((p.mrp - p.price) / p.mrp) * 100) : 0;
  const inWishlist = wishlistIds.includes(p.id);
  return (
    <div className="pk-card group flex flex-col" data-testid={`product-card-${p.slug}`}>
      <Link to={`/product/${p.slug}`} className="relative block aspect-square overflow-hidden bg-muted">
        <img src={p.image} alt={p.name} loading="lazy"
          className="w-full h-full object-cover"
          style={{transition:"transform 0.5s ease"}}
          onMouseOver={e=>e.currentTarget.style.transform="scale(1.06)"}
          onMouseOut={e=>e.currentTarget.style.transform="scale(1)"} />
        {disc > 0 && <span className="absolute top-3 left-3 bg-accent text-white text-[11px] font-bold px-2 py-1 rounded-full">-{disc}%</span>}
        {p.is_best_seller && <span className="absolute top-3 right-3 bg-primary text-white text-[10px] uppercase tracking-wider px-2 py-1 rounded-full">Bestseller</span>}
        <button data-testid={`wishlist-${p.slug}`} onClick={(e)=>{e.preventDefault(); toggleWishlist(p.id);}}
          className="absolute bottom-3 right-3 w-9 h-9 rounded-full bg-white/95 grid place-items-center shadow hover:bg-white">
          <Heart className={`w-4 h-4 ${inWishlist ? "fill-primary text-primary" : "text-primary"}`} />
        </button>
      </Link>
      <div className="p-4 flex-1 flex flex-col">
        <div className="text-[11px] uppercase tracking-widest text-muted-foreground">{p.category?.replace(/-/g," ")}</div>
        <Link to={`/product/${p.slug}`} className="mt-1 font-medium text-[15px] leading-snug line-clamp-2 hover:text-primary">{p.name}</Link>
        <div className="mt-2 flex items-center gap-1 text-xs text-muted-foreground">
          <Star className="w-3.5 h-3.5 fill-secondary text-secondary" />
          <span className="font-semibold text-foreground">{p.rating}</span>
          <span>({p.reviews})</span>
          {p.weight && <><span className="mx-1">·</span><span>{p.weight}</span></>}
        </div>
        <div className="mt-3 flex items-baseline gap-2">
          <span className="text-lg font-semibold text-primary">{fmt(p.price)}</span>
          {p.mrp > p.price && <span className="text-xs line-through text-muted-foreground">{fmt(p.mrp)}</span>}
        </div>
        <button data-testid={`add-to-cart-${p.slug}`} onClick={()=>addToCart({product_id:p.id, name:p.name, price:p.price, image:p.image, slug:p.slug})}
          disabled={p.stock<=0}
          className="mt-3 w-full py-2 rounded-full border border-primary text-primary text-sm font-medium hover:bg-primary hover:text-primary-foreground transition-colors disabled:opacity-50">
          {p.stock<=0 ? "Out of Stock" : "Add to Cart"}
        </button>
      </div>
    </div>
  );
}
